import React from "react";

/** Branded on-screen rendering of the program certificate (landscape). */
export const CertificatePreview = ({ cert }) => {
  if (!cert) return null;
  const issued = cert.issued_at
    ? new Date(cert.issued_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })
    : "";
  return (
    <div
      data-testid="certificate-preview"
      className="relative w-full bg-[#FAFAF7] border-[3px] border-[#222222] rounded-sm shadow-2xl select-none"
      style={{ aspectRatio: "1.414 / 1" }}
    >
      <div className="absolute inset-[1.8%] border border-[#E53935]/70 pointer-events-none" />
      <div className="absolute inset-0 flex flex-col items-center justify-between py-[4.5%] px-[6%] text-center">
        <div className="flex flex-col items-center">
          <img src="/uv-logo-clean.png" alt="UniVicoustic" className="w-[38%] min-w-[160px] object-contain" draggable="false" />
          <div className="mt-2 text-[#222222] font-bold tracking-[0.45em] text-[10px] sm:text-xs">LEARNING ACADEMY</div>
          <div className="mt-0.5 text-[#E53935] font-semibold tracking-[0.35em] text-[8px] sm:text-[10px]">CORPORATE L&amp;D</div>
        </div>

        <div className="flex flex-col items-center">
          <div className="text-slate-500 tracking-[0.25em] text-[10px] sm:text-sm">CERTIFICATE OF COMPLETION</div>
          <div className="w-16 h-[2px] bg-[#E53935] mt-1.5 mb-3 sm:mb-4" />
          <div className="text-[#222222] text-[10px] sm:text-sm">This is to certify that</div>
          <div data-testid="certificate-preview-name" className="font-display font-extrabold text-[#222222] text-xl sm:text-4xl mt-1 sm:mt-2 leading-tight border-b-2 border-[#E53935] pb-1 px-4">
            {cert.full_name}
          </div>
          <div className="text-slate-500 text-[10px] sm:text-sm mt-2 sm:mt-3">has successfully completed</div>
          <div className="text-[#E53935] font-bold text-xs sm:text-xl mt-1 max-w-[85%] leading-snug">
            {cert.program_title}
          </div>
          <div className="text-slate-500 italic text-[8px] sm:text-xs mt-1.5">
            comprising {cert.total_courses || 7} modules of corporate Learning &amp; Development at the {cert.institution}
          </div>
        </div>

        <div className="flex flex-col items-center gap-2 sm:gap-3">
          <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#E53935] flex flex-col items-center justify-center text-white ring-2 ring-white ring-offset-2 ring-offset-[#E53935]/0 shadow-lg" style={{ boxShadow: "0 0 0 2px #E53935, inset 0 0 0 2px rgba(255,255,255,0.8)" }}>
            <div className="font-extrabold text-sm sm:text-lg leading-none">{cert.total_courses || 7}/{cert.total_courses || 7}</div>
            <div className="text-[5px] sm:text-[6px] font-bold tracking-wider mt-0.5">MODULES</div>
          </div>
          <div className="w-full flex items-end justify-between text-[8px] sm:text-[11px]">
            <div className="text-[#222222]">Certificate ID: <span className="font-mono font-semibold">{cert.cert_id}</span></div>
            <div className="text-[#E53935] font-bold">www.univicoustic.com</div>
            <div className="text-[#222222]">Issued: {issued}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificatePreview;
